import { getEnv } from '~/utils';

export function getSegmentWriteKey(): string {
  return getEnv('NEXT_PUBLIC_SEGMENT_IO_KEY');
}
